import React from "react"
import { TagFilter } from "./tagFilter";
import { SearchCategoryCheck } from "./searchCategoryCheck";
import { Searcher } from "./searcher";
import { Switching } from "./switching";
import { SearchCategoryList } from "./searchCategoryList";
import { filterAreas, optionsJob } from "./mock";
import { Checkboxes } from '../../../../@shared/elements/checkbox'
import {Radios} from '../../../../@shared/elements/radio/radio'

export const FilterVertical = () =>{
    const [tab,setTab] = React.useState(1)
    return (
      <div className="project-form">
          <div>
            <div className="filter-tabs">
              <ul>
                <li onClick={() => setTab(1)} className={`${tab === 1 && 'active'}`}>
                  General
                </li>
                <li onClick={() => setTab(2)} className={`${tab === 2 && 'active'}`}>
                  Category
                </li>
                <li onClick={() => setTab(3)} className={`${tab === 3 && 'active'}`}>
                  Project
                </li>
              </ul>
            </div>
            <div className="project-filter ">
  
              {tab === 1 && (
                <div className="filter_component scrolling">
                  {/** investor limit, price range, **/}
                  <Searcher />
                  <Checkboxes title="Rooms" data={optionsJob} />
                  <TagFilter />
                  <Switching />
  
                </div>
              )}
              {tab === 2 && (
                <div className="filter_component scrolling">
                  <SearchCategoryList />
  
                </div>
              )}
              {tab === 3 && (
                <div className="filter_component scrolling">
                  <SearchCategoryCheck title="Sectors" />
                  <Radios title="Types" data={filterAreas} />
                  <TagFilter title="Sectors" />
  
                </div>
              )}
  
            </div>
            <div className="bottom">
              <button className="search">Filter</button>
            </div>
          </div>
        </div>
    )
}
  
export default FilterVertical;





